import classNames from 'classnames';
import * as React from 'react';

interface Props {
    size: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    withDivider?: boolean;
    margin?: 'no' | 'quarter';
    variations?: string[];
    children: React.ReactNode;
}

const Heading: React.FunctionComponent<Props> = ({ variations, ...props }) => {
    const className = classNames('heading', `heading--${props.size}`, variations, {
        'heading--with-divider': props.withDivider,
        [`heading--${props.margin}-margin`]: props.margin,
    });

    return React.createElement(props.size, { className }, props.children);
};

export default Heading;
